// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"0a88a8d5","187":"b981e398","344":"e6fdcb88"}[chunkId] + ".chunk.js";
};